var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebDevelopmntFeatured2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.39067 1.72398C8.14068 1.47391 7.80159 1.33339 7.448 1.33331H2.66667C2.31304 1.33331 1.9739 1.47379 1.72386 1.72384C1.47381 1.97389 1.33333 2.31302 1.33333 2.66665V7.44798C1.33341 7.80157 1.47393 8.14066 1.724 8.39065L7.52667 14.1933C7.82967 14.4944 8.2395 14.6634 8.66667 14.6634C9.09383 14.6634 9.50366 14.4944 9.80667 14.1933L14.1933 9.80665C14.4944 9.50364 14.6634 9.09382 14.6634 8.66665C14.6634 8.23948 14.4944 7.82966 14.1933 7.52665L8.39067 1.72398Z",
    stroke: "#057DCD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5.33335C5.1841 5.33335 5.33333 5.18412 5.33333 5.00002C5.33333 4.81593 5.1841 4.66669 5 4.66669C4.81591 4.66669 4.66667 4.81593 4.66667 5.00002C4.66667 5.18412 4.81591 5.33335 5 5.33335Z",
    fill: "#057DCD",
    stroke: "#057DCD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDevelopmntFeatured2);
export default __webpack_public_path__ + "static/media/WebDevelopmntFeatured (2).5faeb9f8cd745ad7b5c3ba772bc19828.svg";
export { ForwardRef as ReactComponent };